export const API = axios.create();
const onRequest = (req) => req;
const onRequestError = (err) => Promise.reject(err);
const onResponse = (res) => Promise.resolve(res.data.data);
const onResponseError = (err) => Promise.reject(err);
API.interceptors.request.use(onRequest, onRequestError);
API.interceptors.response.use(onResponse, onResponseError);
